<template>
  <div>
      <p>Чтобы заполнить контент нажмите на "открыть редактор"</p>
      <button @click="$store.dispatch('setPost',id)" class="btn btn-info mb-4">Открыть редактор</button>
    </div>
</template>

<script>
export default {
  props: {
    id: {
      default: "",
    },
  },
  name: "filter",
  components: {

  },
  methods: {

  }
};
</script>
